export function footer() {

	let greyFooter      = $('.js-grey-footer');
	let removeFooter    = $('.js-footer-hidden')

	if(greyFooter.length) {
		greyFooter.closest('body').find('.page-footer').removeClass('bg--blue');
		greyFooter.closest('body').find('.page-footer').addClass('bg--grey-100');
	}

	if(removeFooter.length) {
		removeFooter.closest('body').addClass('footer--hidden')
	}

	return 'footer';
}